import { DebugEvent } from 'core/DebugEvent';
import { UIThemeColourType } from 'app/data/Enums';

interface UIThemeChangeEventInterface {
	theme: UIThemeColourType;
}

export class UIThemeChangeEvent extends DebugEvent implements UIThemeChangeEventInterface {
	public static eventName: string = 'UI_THEME_CHANGE_EVENT';
	public theme: UIThemeColourType;

	constructor(parameters: UIThemeChangeEventInterface) {
		super(parameters);
	}
}
